module.exports = __webpack_public_path__ + "static/media/ipad.906c1a42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/EnergyCompany/img/ipad.png
// module id = 977
// module chunks = 0